<template>
  <div class="error">
    <h1>404 </h1>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.error{
  background-color: #fff;
  min-height: 100vh;
  padding-top: 100px;
}
  h1{
    text-align: center;
    font-size: 100px;
  }
</style>